module.exports = __webpack_public_path__ + "media/assets/services_manager/flags/turkish-f47b07e0f7d37bde5b1f951958e1e96ec2ba4123eb549a14c0b2ec4923a13c6d.png";